import React, { Fragment } from 'react';
import { Button, Checkbox, Divider, Form, Grid, Header, Loader, Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import { DateTimePicker } from 'react-widgets';
import { toast, ToastContainer } from 'react-toastify';

const types = [
    {
        key: 1,
        value: 1,
        text: 'podaci sa starog plana i programa'
    },
    {
        key: 2,
        value: 2,
        text: 'podaci sa novog plana i programa'
    }
];

export default class AddExamRecognition extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            student: JSON.parse(localStorage.getItem('student')),
            newStudyProgram: JSON.parse(localStorage.getItem('newStudyProgram')),
            semesterNumOptions: [],
            grade: null,
            course: null,
            newCourse: '',
            semesterNum: '',
            date: new Date(),
            type: 1,
            comment: ''
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.getGrades = this.getGrades.bind(this);
        this.closeAddMode = this.closeAddMode.bind(this);
        this.getCourses = this.getCourses.bind(this);
        this.getSemesterNumOptions = this.getSemesterNumOptions.bind(this);
        this.addCourse = this.addCourse.bind(this);
        this.resetForm = this.resetForm.bind(this);
    }

    componentDidMount() {
        this.getGrades();
        this.getCourses();
    }

    closeAddMode() {
        this.props.closeAddMode();
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'course') {
            if (this.state.type === 1) this.getSemesterNumOptions(value.el.courseStudyProgramId);
        }
        if (name === 'newCourse') { if (this.state.type === 2) this.getSemesterNumOptions(value); }
        if (name === 'type') {
            this.resetForm();
        }
        this.setState({
            [name]: value
        });
    }

    getGrades() {
        this.setState({ loader: true });
        axios.get(`/student-exams/for-recognition/${this.state.student.id}/`)
            .then(res => {
                this.setState({
                    grades: res.data.map(el => ({
                        key: el.courseBasicId, value: { id: el.courseBasicId, el: { ...el } }, text: el.courseBasicName + (el.code === null ? '' : '   |   ' + el.code) + '   |   ' + el.mark
                    })),
                    loader: false,
                });
            });
    }

    getCourses() {
        axios.get(`/course/not-passed-and-not-enrolled/${this.state.newStudyProgram.id}/`)
            .then(res => {
                this.setState({
                    courseOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.courseBasicName + ' | ' + (el.code ? el.code : '')
                    }))
                });
            });
    }


    getSemesterNumOptions(id) {
        axios.get(`/study-programs/courses/semesters/${id}/`)
            .then(res => {
                this.setState({
                    semesterNumOptions: res.data.map(el => ({
                        ...el, key: el.studyProgramSemester.id, value: el.studyProgramSemester.id, text: el.studyProgramSemester.name
                    }))
                });
                if (this.state.semesterNumOptions.length === 1) this.setState({ semesterNum: this.state.semesterNumOptions[0].value });
            });
    }

    resetForm() {
        this.setState({

            course: null,
            newCourse: null,
            semesterNum: null,
            comment: null,
            semesterNumOptions: []

        });
    }

    addCourse() {
        if (!this.state.course || !this.state.semesterNum || !this.state.type) {
            toast('Niste unijeli sve podatke.');
            if (!this.state.course) { this.setState({ courseErr: true }); } else { this.setState({ courseErr: false }); }
            if (!this.state.newCourse) { this.setState({ newCourseErr: true }); } else { this.setState({ newCourseErr: false }); }
            if (!this.state.semesterNum) { this.setState({ semesterNumErr: true }); } else { this.setState({ semesterNumErr: false }); }
            if (!this.state.type) { this.setState({ typeErr: true }); } else { this.setState({ typeErr: false }); }
        } else {
            this.setState({ loader: true });
            let obj = {
                studentStudyProgram: { id: this.state.newStudyProgram.id },
                previousCourseStudyProgram: { id: this.state.course.el.courseStudyProgramId },
                currentCourseStudyProgram: this.state.newCourse ? { id: this.state.newCourse } : null,
                studyProgramSemester: { id: this.state.semesterNum },
                mark: { id: this.state.course.el.markId },
                previousCourseInformation: this.state.type === 2 ? 0 : this.state.type === 1 ? 1 : null,
                date: this.state.type === 1 ? this.state.course.el.examDate : this.state.date,
                comment: this.state.comment
            };

            axios.post('/student-study-program-exam-recognition/add/', { ...obj })
                .then(res => {
                    toast('Studentu je uspješno priznat predmet.');
                    this.setState({
                        loader: false
                    });
                    this.resetForm();
                    // this.closeAddMode();
                    this.props.getExamRecognition();
                })
                .catch(err => {
                    this.setState({ loader: false });
                    if (err.response.data === 'Exam recognition for this course is already added!') {
                        toast('Studentu je predmet već priznat!');
                    } else if (err.response.data === 'Current course study program must be specified because previousCourseInformation is false!') {
                        toast('Potrebno je odabrati predmet na trenutnom planu i programu');
                    } else {
                        toast('Došlo je do greške! Studentu nije priznat predmet.');
                    }
                });
        }
    }

    render() {
        return (
            <div>
                <Segment secondary clearing>
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field required error={this.state.typeErr}>
                                <label>Prikazuju se</label>
                                <Form.Dropdown
                                    clearable
                                    placeholder="Odaberite način prikazivanja"
                                    value={this.state.type}
                                    defaultValue={this.state.type}
                                    onChange={this.handleInputChange}
                                    name="type"
                                    options={types}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                            <Form.Field required error={this.state.semesterNumErr} >
                                <label>Semestar</label>
                                <Form.Dropdown
                                    clearable
                                    placeholder="Odaberite semestar"
                                    disabled={this.state.semesterNumOptions.length === 1 || !this.state.course || !this.state.newCourse}
                                    value={this.state.semesterNumOptions.length === 1 ? this.state.semesterNumOptions[0].value : this.state.semesterNum}
                                    onChange={this.handleInputChange}
                                    name="semesterNum"
                                    options={this.state.semesterNumOptions}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                            <Form.Field
                                control={DateTimePicker}
                                label="Datum ocjene"
                                format="D. M. YYYY."
                                defaultValue={this.state.date}
                                placeholder="Unesite datum ocjene"
                                time={false}
                                disabled={this.state.type !== 2}
                                onChange={this.handleDateChange.bind(null, 'date')}
                                style={{ borderWidth: '0px' }}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Field required error={this.state.courseErr} width={8}>
                                <label>Predmet koji se priznaje</label>
                                <Form.Dropdown
                                    clearable
                                    placeholder="Odaberite ocjenu"
                                    value={this.state.course}
                                    onChange={this.handleInputChange}
                                    name="course"
                                    options={this.state.grades}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                            <Form.Field width={8}>
                                <label>Priznaje se kao</label>
                                <Form.Dropdown
                                    clearable
                                    placeholder="Odaberite predmet"
                                    value={this.state.newCourse}
                                    onChange={this.handleInputChange}
                                    name="newCourse"
                                    options={this.state.courseOptions}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                        </Form.Group>

                        <Button color="blue" basic="true" floated="right" onClick={this.closeAddMode}>Odustani</Button>
                        <Button
                            floated="right"
                            color="blue"
                            onClick={this.addCourse}
                        >Dodaj</Button>
                        <br />
                        <br />
                    </Form>
                </Segment>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/ExamRecognition/AddExamRecognition.js